module.exports = __webpack_public_path__ + "static/media/charles_icon.6bc5c6a3.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/content/charles_icon.jpeg
// module id = 28
// module chunks = 0